import { CopyrightOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
const {
  Footer
} = Layout;
import MainFooter from './MainFooter';
import classes from './footer.module.less';
const Footers = () => {
  const d = new Date();
  const year = d.getFullYear();
  return <div className={classes['page-body-wrap']}>
			<div className="container">
				<Footer className={classes.allFooter}>
					<MainFooter />
					<div className={classes.footer}>
						<CopyrightOutlined />
						&nbsp;
						{year} HalloBumil. All rights reserved.
					</div>
				</Footer>
			</div>
		</div>;
};
export default Footers;